/**  @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import classNames from 'classnames';
import Slider from 'rc-slider';

import { isRightToLeft } from 'js/lib/language';

import { color } from '@coursera/coursera-ui';

import _t from 'i18n!nls/general-video-player';

import 'css!rc-slider/assets/index';

const styles = {
  volumeMenuPopupContainer: css`
    height: 100%;
    padding-right: 5px;
    color: #fff;
    width: 0;
    visibility: hidden;
    transition: visibility 0s 0.1s, width 0.1s linear;
  `,
  modernVolumeMenuPopupContainer: css`
    padding-right: 0;
  `,
  visible: css`
    width: 100px;
    visibility: visible;
    transition: width 0.1s linear;

    > .rc-slider {
      width: 75%;
    }

    .rc-VolumeSlider {
      height: 24px;
      padding: 10px 0;
      margin-right: 5px;
    }
  `,
};

type Props = {
  visible: boolean;
  volume: number;
  muted: boolean;
  onVolumeSliderChange: (value: number) => void;
  onBeforeChange: () => void;
  onAfterChange: () => void;
};

type SliderRef = {
  sliderRef: HTMLElement | null;
};

const VolumeMenuPopup = ({ visible, volume, muted, onVolumeSliderChange, onBeforeChange, onAfterChange }: Props) => {
  const volumeSliderRef = React.useRef<SliderRef | null>(null);
  const label = _t('Volume Control Slider');

  React.useEffect(() => {
    volumeSliderRef?.current?.sliderRef?.querySelector('.rc-slider-handle')?.setAttribute('aria-label', label);
  }, [label]);

  const handleStyleModernVideoPlayerGating = {
    borderColor: color.white,
    height: '10px',
    width: '10px',
    marginLeft: '-5px',
    marginTop: '-3px',
    cursor: 'pointer',
  };

  return (
    <div
      className={classNames('rc-VolumeMenuPopup', 'horizontal-box', 'align-items-absolute-center', { visible })}
      css={[styles.volumeMenuPopupContainer, visible && styles.visible]}
    >
      <Slider
        ref={volumeSliderRef as React.RefObject<Slider>}
        className="rc-VolumeSlider"
        value={muted ? 0 : volume * 100}
        onChange={onVolumeSliderChange}
        onBeforeChange={onBeforeChange}
        onAfterChange={onAfterChange}
        trackStyle={{
          backgroundColor: color.white,
          cursor: 'pointer',
        }}
        handleStyle={handleStyleModernVideoPlayerGating}
        railStyle={{
          backgroundColor: '#aaa',
        }}
        reverse={isRightToLeft(_t.getLocale())}
      />
    </div>
  );
};

export default VolumeMenuPopup;
